/**
@format
@flow local-strict
*/

import * as React from 'react';
import { SelectDropdown as KrispySelectDropdown } from '@krispy/selects/web';
import Colors from '@ziynx/theme/colors';
import { Constants } from '@ziynx/components/layout';

type Props = $ReadOnly<{|
  /**
   * Label when input field is focused/active.
   */
  activeLabel?: string,
  /**
   * Label if standalone
   */
  label?: string,

  /**
   * Input label color
   */
  labelColor?: string,

  /**
   * Required label color if required is true
   */
  requiredColor?: string,

  /**
   * Name for input to be handled in forms
   */
  inputName: string,

  /**
   * If true, input is required
   */
  required?: boolean,

  /**
   * If true, input is read-only, can't edit
   */
  readOnly?: boolean,

  /**
   * Aria label for inputs
   */
  ariaLabel?: string,

  /**
   * Name for input to be handled in forms
   */
  inputName: string,
  /**
   * Value for input to be handled in forms
  */
  defaultValue: string,

  /**
   * If input is disabled
   */
  disabled?: boolean,

  /**
   * If error (passed from Input) is true, border is SecondaryRed
   */
  error?: boolean,

  /**
   * Array of options to select from
   */
  options: Array<any>,
  /**
   * Error Label
   */
  errorLabel?: string,
  /**
   * Error Label color
   */
  errorLabelColor?: string,
  /**
   * Helper Label
   */
  helperLabel?: string,
  /**
   * Helper Label color
   */
  helperLabelColor?: string,
|}>;

/* Select input component */
export default function Dropdown(props: Props): React$Node {
  return <KrispySelectDropdown {...props} colorConfig={Colors} layoutConfig={Constants} />;
}

Dropdown.defaultProps = {
  requiredColor: Colors.SecondaryRed,
};
